<template>
      <div class="wrapper flex xs-middle" :class="status">
            <!-- Slot for icons -->
            <slot name="icon" v-if="this.value === '' || this.value === null"></slot>
            <input
                  type="password"
                  class="afizo22"
                  :class="[size, status]"
                  :value="value"
                  @focus="$emit('focus')"
                  @blur="$emit('blur')"
                  @input="$emit('input', $event.target.value)"
                  data-fup="input/password"
            />
      </div>
</template>

<script>
export default {
	props: {
		value: {
			required: true,
			default: null,
			validator(val) {
				return val === null || typeof val === "string"
			}
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					[
						"xsmall",
						"small",
						"medium",
						"large",
						"xlarge"
					].includes(val)
				)
			}
		},
		status: {
			required: false,
			default: null,
			validator(val) {
				return (
					val === null ||
					["error", "success", "warning"].includes(val)
				)
			}
		}
	}
}
</script>

<style src="./index.css" scoped />
